import * as React from "react";
const SvgPencil = props => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={17} fill="none" viewBox="0 0 16 17" {...props}><path fill="#303342" fillOpacity={0.4} d="M.5 13 9 4l3.5 3.5-8 8.5-4 1zM14 6l2-2L12.5.5l-2 2z" /></svg>;
export default SvgPencil;